import MtnMoneyLogo from '~/assets/images/mtnmoney-logo.png';
import OrangeLogo from '~/assets/images/orangemoney-logo.png';
import MoovMoneyLogo from '~/assets/images/moov-money.png';
import AirtelLogo from '~/assets/images/airtel-logo.png';
import SwapLogo from '~/assets/images/swap-logo.png';

const OPERATOR_LOGO_MAP: Array<{ keywords: RegExp; logo: string }> = [
  { keywords: /\b(MTN|Mtn)\b/i, logo: MtnMoneyLogo },
  { keywords: /\b(Orange|ORANGE)\b/i, logo: OrangeLogo },
  { keywords: /\b(Moov|MOOV)\b/i, logo: MoovMoneyLogo },
  { keywords: /\b(Airtel|AIRTEL)\b/i, logo: AirtelLogo },
  { keywords: /\b(Swap|SWAP)\b/i, logo: SwapLogo },
];

export function getParticipantLogo(participant: { name: string; shortName: string }): string | null {
  const text = `${participant.name} ${participant.shortName}`;
  const match = OPERATOR_LOGO_MAP.find(({ keywords }) => keywords.test(text));
  return match ? match.logo : null;
}
